module.exports = __webpack_public_path__ + "img/eth.7c199546.svg";